import React from 'react';
import Badge from '../../../Badge';

// import { Container } from './styles';
export interface StatusType {
  id: number;
  label: string;
  color: string;
  icon: string;
}

interface Props {
  data: StatusType[];
  status: number;
  statusData?: StatusType;
}

const Status: React.FC<Props> = ({ data, status, statusData }: Props) => {
  const resolvedStatus = statusData || data.find((item: StatusType) => item.id == status);

  return (
    <Badge content={resolvedStatus?.label} color={resolvedStatus?.color} icon={resolvedStatus?.icon} />
  );
}

export default Status;